import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PersistanceStrategyService {
  private resourceCache: { [key: string]: any };

  constructor() {
    this.clear();
  }

  clear() {
    this.resourceCache = {};
  }

  clearItems(keys: string[]): boolean {
    let itemDeleted = false;
    keys.forEach((key: string) => {
      if (this.resourceCache[key]) {
        delete this.resourceCache[key];
        itemDeleted = true;
      }
    });
    return itemDeleted;
  }

  getItem<T>(key: string): T {
    return this.resourceCache[key];
  }

  persistItem<T>(key: string, item: T) {
    this.resourceCache[key] = item;
  }

  isEmpty() {
    return Object.keys(this.resourceCache).length === 0;
  }
}
